// Column labels and default visible columns for the OMS Order list (summary table only).

export const columnLabels = {
  __actions: "",
  marketplaceName: "Marketplace Name",
  marketplaceOrderId: "Marketplace Order ID",
  omsOrderId: "OMS Order ID",
  orderType: "Order Type",
  orderDate: "Order Date",
  orderStatus: "Order Status",
  customerName: "Customer Name",
  paymentStatus: "Payment Status",
  fulfillmentType: "Fulfillment Type",
};

/** Main fields shown on the order list page (high-signal columns only). */
export const defaultVisibleFields = [
  "__actions",
  "omsOrderId",
  "marketplaceOrderId",
  "marketplaceName",
  "orderDate",
  "orderStatus",
  "orderType",
  "customerName",
  "paymentStatus",
  "fulfillmentType",
];

export const getColumnLabel = (field, startCaseFn) =>
  columnLabels[field] || startCaseFn(field);
